/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WeeklyPlanRouteImport } from './routes/weekly-plan'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as SiteInspectionsRouteImport } from './routes/site-inspections'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PatientsRouteImport } from './routes/patients'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JobRolesRouteImport } from './routes/job-roles'
import { Route as ExamsRouteImport } from './routes/exams'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as CorporateRouteImport } from './routes/corporate'
import { Route as CompaniesRouteImport } from './routes/companies'
import { Route as ClinicsRouteImport } from './routes/clinics'
import { Route as BookingsRouteImport } from './routes/bookings'
import { Route as AdminEmailRouteImport } from './routes/admin-email'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersNewRouteImport } from './routes/users_.new'
import { Route as TicketsNewRouteImport } from './routes/tickets_.new'
import { Route as TicketsTicketIdRouteImport } from './routes/tickets_.$ticketId'
import { Route as SiteInspectionsNewRouteImport } from './routes/site-inspections_.new'
import { Route as PatientsNewRouteImport } from './routes/patients_.new'
import { Route as PatientsImportRouteImport } from './routes/patients_.import'
import { Route as JobRolesNewRouteImport } from './routes/job-roles_.new'
import { Route as ExamsNewRouteImport } from './routes/exams_.new'
import { Route as DocumentsUploadRouteImport } from './routes/documents_.upload'
import { Route as DocumentsBulkIdoneitaRouteImport } from './routes/documents_.bulk-idoneita'
import { Route as CorporateBookingsRouteImport } from './routes/corporate_.bookings'
import { Route as CompaniesNewRouteImport } from './routes/companies_.new'
import { Route as ClinicsNewRouteImport } from './routes/clinics_.new'
import { Route as BookingsSearchRouteImport } from './routes/bookings_.search'
import { Route as BookingsNewRouteImport } from './routes/bookings_.new'
import { Route as UsersUserIdSignatureRouteImport } from './routes/users_.$userId.signature'
import { Route as UsersUserIdEditRouteImport } from './routes/users_.$userId.edit'
import { Route as UsersUserIdDeleteRouteImport } from './routes/users_.$userId.delete'
import { Route as UsersUserIdAvailabilityRouteImport } from './routes/users_.$userId.availability'
import { Route as SiteInspectionsSiteInspectionIdEditRouteImport } from './routes/site-inspections_.$siteInspectionId.edit'
import { Route as SiteInspectionsSiteInspectionIdDeleteRouteImport } from './routes/site-inspections_.$siteInspectionId.delete'
import { Route as PatientsPatientIdEditRouteImport } from './routes/patients_.$patientId.edit'
import { Route as PatientsPatientIdDeleteRouteImport } from './routes/patients_.$patientId.delete'
import { Route as JobRolesJobRoleIdEditRouteImport } from './routes/job-roles_.$jobRoleId.edit'
import { Route as JobRolesJobRoleIdDeleteRouteImport } from './routes/job-roles_.$jobRoleId.delete'
import { Route as ExamsExamIdEditRouteImport } from './routes/exams_.$examId.edit'
import { Route as ExamsExamIdDeleteRouteImport } from './routes/exams_.$examId.delete'
import { Route as DocumentsDocumentIdEditRouteImport } from './routes/documents_.$documentId.edit'
import { Route as DocumentsDocumentIdDeleteRouteImport } from './routes/documents_.$documentId.delete'
import { Route as CompaniesCompanyIdEditRouteImport } from './routes/companies_.$companyId.edit'
import { Route as CompaniesCompanyIdDeleteRouteImport } from './routes/companies_.$companyId.delete'
import { Route as CompaniesCompanyIdContractRouteImport } from './routes/companies_.$companyId.contract'
import { Route as ClinicsClinicIdEditRouteImport } from './routes/clinics_.$clinicId.edit'
import { Route as ClinicsClinicIdDeleteRouteImport } from './routes/clinics_.$clinicId.delete'
import { Route as BookingsBookingIdEditRouteImport } from './routes/bookings_.$bookingId.edit'
import { Route as BookingsBookingIdDeleteRouteImport } from './routes/bookings_.$bookingId.delete'

const WeeklyPlanRoute = WeeklyPlanRouteImport.update({
  id: '/weekly-plan',
  path: '/weekly-plan',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteInspectionsRoute = SiteInspectionsRouteImport.update({
  id: '/site-inspections',
  path: '/site-inspections',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsRoute = PatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JobRolesRoute = JobRolesRouteImport.update({
  id: '/job-roles',
  path: '/job-roles',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamsRoute = ExamsRouteImport.update({
  id: '/exams',
  path: '/exams',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const CorporateRoute = CorporateRouteImport.update({
  id: '/corporate',
  path: '/corporate',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicsRoute = ClinicsRouteImport.update({
  id: '/clinics',
  path: '/clinics',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsRoute = BookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailRoute = AdminEmailRouteImport.update({
  id: '/admin-email',
  path: '/admin-email',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersNewRoute = UsersNewRouteImport.update({
  id: '/users_/new',
  path: '/users/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsNewRoute = TicketsNewRouteImport.update({
  id: '/tickets_/new',
  path: '/tickets/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
  id: '/tickets_/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteInspectionsNewRoute = SiteInspectionsNewRouteImport.update({
  id: '/site-inspections_/new',
  path: '/site-inspections/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsNewRoute = PatientsNewRouteImport.update({
  id: '/patients_/new',
  path: '/patients/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsImportRoute = PatientsImportRouteImport.update({
  id: '/patients_/import',
  path: '/patients/import',
  getParentRoute: () => rootRouteImport,
} as any)
const JobRolesNewRoute = JobRolesNewRouteImport.update({
  id: '/job-roles_/new',
  path: '/job-roles/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamsNewRoute = ExamsNewRouteImport.update({
  id: '/exams_/new',
  path: '/exams/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsUploadRoute = DocumentsUploadRouteImport.update({
  id: '/documents_/upload',
  path: '/documents/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsBulkIdoneitaRoute = DocumentsBulkIdoneitaRouteImport.update({
  id: '/documents_/bulk-idoneita',
  path: '/documents/bulk-idoneita',
  getParentRoute: () => rootRouteImport,
} as any)
const CorporateBookingsRoute = CorporateBookingsRouteImport.update({
  id: '/corporate_/bookings',
  path: '/corporate/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesNewRoute = CompaniesNewRouteImport.update({
  id: '/companies_/new',
  path: '/companies/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicsNewRoute = ClinicsNewRouteImport.update({
  id: '/clinics_/new',
  path: '/clinics/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsSearchRoute = BookingsSearchRouteImport.update({
  id: '/bookings_/search',
  path: '/bookings/search',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsNewRoute = BookingsNewRouteImport.update({
  id: '/bookings_/new',
  path: '/bookings/new',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdSignatureRoute = UsersUserIdSignatureRouteImport.update({
  id: '/users_/$userId/signature',
  path: '/users/$userId/signature',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdEditRoute = UsersUserIdEditRouteImport.update({
  id: '/users_/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdDeleteRoute = UsersUserIdDeleteRouteImport.update({
  id: '/users_/$userId/delete',
  path: '/users/$userId/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdAvailabilityRoute = UsersUserIdAvailabilityRouteImport.update({
  id: '/users_/$userId/availability',
  path: '/users/$userId/availability',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteInspectionsSiteInspectionIdEditRoute =
  SiteInspectionsSiteInspectionIdEditRouteImport.update({
    id: '/site-inspections_/$siteInspectionId/edit',
    path: '/site-inspections/$siteInspectionId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const SiteInspectionsSiteInspectionIdDeleteRoute =
  SiteInspectionsSiteInspectionIdDeleteRouteImport.update({
    id: '/site-inspections_/$siteInspectionId/delete',
    path: '/site-inspections/$siteInspectionId/delete',
    getParentRoute: () => rootRouteImport,
  } as any)
const PatientsPatientIdEditRoute = PatientsPatientIdEditRouteImport.update({
  id: '/patients_/$patientId/edit',
  path: '/patients/$patientId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsPatientIdDeleteRoute = PatientsPatientIdDeleteRouteImport.update({
  id: '/patients_/$patientId/delete',
  path: '/patients/$patientId/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const JobRolesJobRoleIdEditRoute = JobRolesJobRoleIdEditRouteImport.update({
  id: '/job-roles_/$jobRoleId/edit',
  path: '/job-roles/$jobRoleId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const JobRolesJobRoleIdDeleteRoute = JobRolesJobRoleIdDeleteRouteImport.update({
  id: '/job-roles_/$jobRoleId/delete',
  path: '/job-roles/$jobRoleId/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamsExamIdEditRoute = ExamsExamIdEditRouteImport.update({
  id: '/exams_/$examId/edit',
  path: '/exams/$examId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ExamsExamIdDeleteRoute = ExamsExamIdDeleteRouteImport.update({
  id: '/exams_/$examId/delete',
  path: '/exams/$examId/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsDocumentIdEditRoute = DocumentsDocumentIdEditRouteImport.update({
  id: '/documents_/$documentId/edit',
  path: '/documents/$documentId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsDocumentIdDeleteRoute =
  DocumentsDocumentIdDeleteRouteImport.update({
    id: '/documents_/$documentId/delete',
    path: '/documents/$documentId/delete',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdEditRoute = CompaniesCompanyIdEditRouteImport.update({
  id: '/companies_/$companyId/edit',
  path: '/companies/$companyId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdDeleteRoute =
  CompaniesCompanyIdDeleteRouteImport.update({
    id: '/companies_/$companyId/delete',
    path: '/companies/$companyId/delete',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompaniesCompanyIdContractRoute =
  CompaniesCompanyIdContractRouteImport.update({
    id: '/companies_/$companyId/contract',
    path: '/companies/$companyId/contract',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClinicsClinicIdEditRoute = ClinicsClinicIdEditRouteImport.update({
  id: '/clinics_/$clinicId/edit',
  path: '/clinics/$clinicId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicsClinicIdDeleteRoute = ClinicsClinicIdDeleteRouteImport.update({
  id: '/clinics_/$clinicId/delete',
  path: '/clinics/$clinicId/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsBookingIdEditRoute = BookingsBookingIdEditRouteImport.update({
  id: '/bookings_/$bookingId/edit',
  path: '/bookings/$bookingId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsBookingIdDeleteRoute = BookingsBookingIdDeleteRouteImport.update({
  id: '/bookings_/$bookingId/delete',
  path: '/bookings/$bookingId/delete',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin-email': typeof AdminEmailRoute
  '/bookings': typeof BookingsRoute
  '/clinics': typeof ClinicsRoute
  '/companies': typeof CompaniesRoute
  '/corporate': typeof CorporateRoute
  '/documents': typeof DocumentsRoute
  '/exams': typeof ExamsRoute
  '/job-roles': typeof JobRolesRoute
  '/login': typeof LoginRoute
  '/patients': typeof PatientsRoute
  '/profile': typeof ProfileRoute
  '/site-inspections': typeof SiteInspectionsRoute
  '/tickets': typeof TicketsRoute
  '/users': typeof UsersRoute
  '/weekly-plan': typeof WeeklyPlanRoute
  '/bookings/new': typeof BookingsNewRoute
  '/bookings/search': typeof BookingsSearchRoute
  '/clinics/new': typeof ClinicsNewRoute
  '/companies/new': typeof CompaniesNewRoute
  '/corporate/bookings': typeof CorporateBookingsRoute
  '/documents/bulk-idoneita': typeof DocumentsBulkIdoneitaRoute
  '/documents/upload': typeof DocumentsUploadRoute
  '/exams/new': typeof ExamsNewRoute
  '/job-roles/new': typeof JobRolesNewRoute
  '/patients/import': typeof PatientsImportRoute
  '/patients/new': typeof PatientsNewRoute
  '/site-inspections/new': typeof SiteInspectionsNewRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/users/new': typeof UsersNewRoute
  '/bookings/$bookingId/delete': typeof BookingsBookingIdDeleteRoute
  '/bookings/$bookingId/edit': typeof BookingsBookingIdEditRoute
  '/clinics/$clinicId/delete': typeof ClinicsClinicIdDeleteRoute
  '/clinics/$clinicId/edit': typeof ClinicsClinicIdEditRoute
  '/companies/$companyId/contract': typeof CompaniesCompanyIdContractRoute
  '/companies/$companyId/delete': typeof CompaniesCompanyIdDeleteRoute
  '/companies/$companyId/edit': typeof CompaniesCompanyIdEditRoute
  '/documents/$documentId/delete': typeof DocumentsDocumentIdDeleteRoute
  '/documents/$documentId/edit': typeof DocumentsDocumentIdEditRoute
  '/exams/$examId/delete': typeof ExamsExamIdDeleteRoute
  '/exams/$examId/edit': typeof ExamsExamIdEditRoute
  '/job-roles/$jobRoleId/delete': typeof JobRolesJobRoleIdDeleteRoute
  '/job-roles/$jobRoleId/edit': typeof JobRolesJobRoleIdEditRoute
  '/patients/$patientId/delete': typeof PatientsPatientIdDeleteRoute
  '/patients/$patientId/edit': typeof PatientsPatientIdEditRoute
  '/site-inspections/$siteInspectionId/delete': typeof SiteInspectionsSiteInspectionIdDeleteRoute
  '/site-inspections/$siteInspectionId/edit': typeof SiteInspectionsSiteInspectionIdEditRoute
  '/users/$userId/availability': typeof UsersUserIdAvailabilityRoute
  '/users/$userId/delete': typeof UsersUserIdDeleteRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/users/$userId/signature': typeof UsersUserIdSignatureRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-email': typeof AdminEmailRoute
  '/bookings': typeof BookingsRoute
  '/clinics': typeof ClinicsRoute
  '/companies': typeof CompaniesRoute
  '/corporate': typeof CorporateRoute
  '/documents': typeof DocumentsRoute
  '/exams': typeof ExamsRoute
  '/job-roles': typeof JobRolesRoute
  '/login': typeof LoginRoute
  '/patients': typeof PatientsRoute
  '/profile': typeof ProfileRoute
  '/site-inspections': typeof SiteInspectionsRoute
  '/tickets': typeof TicketsRoute
  '/users': typeof UsersRoute
  '/weekly-plan': typeof WeeklyPlanRoute
  '/bookings/new': typeof BookingsNewRoute
  '/bookings/search': typeof BookingsSearchRoute
  '/clinics/new': typeof ClinicsNewRoute
  '/companies/new': typeof CompaniesNewRoute
  '/corporate/bookings': typeof CorporateBookingsRoute
  '/documents/bulk-idoneita': typeof DocumentsBulkIdoneitaRoute
  '/documents/upload': typeof DocumentsUploadRoute
  '/exams/new': typeof ExamsNewRoute
  '/job-roles/new': typeof JobRolesNewRoute
  '/patients/import': typeof PatientsImportRoute
  '/patients/new': typeof PatientsNewRoute
  '/site-inspections/new': typeof SiteInspectionsNewRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/users/new': typeof UsersNewRoute
  '/bookings/$bookingId/delete': typeof BookingsBookingIdDeleteRoute
  '/bookings/$bookingId/edit': typeof BookingsBookingIdEditRoute
  '/clinics/$clinicId/delete': typeof ClinicsClinicIdDeleteRoute
  '/clinics/$clinicId/edit': typeof ClinicsClinicIdEditRoute
  '/companies/$companyId/contract': typeof CompaniesCompanyIdContractRoute
  '/companies/$companyId/delete': typeof CompaniesCompanyIdDeleteRoute
  '/companies/$companyId/edit': typeof CompaniesCompanyIdEditRoute
  '/documents/$documentId/delete': typeof DocumentsDocumentIdDeleteRoute
  '/documents/$documentId/edit': typeof DocumentsDocumentIdEditRoute
  '/exams/$examId/delete': typeof ExamsExamIdDeleteRoute
  '/exams/$examId/edit': typeof ExamsExamIdEditRoute
  '/job-roles/$jobRoleId/delete': typeof JobRolesJobRoleIdDeleteRoute
  '/job-roles/$jobRoleId/edit': typeof JobRolesJobRoleIdEditRoute
  '/patients/$patientId/delete': typeof PatientsPatientIdDeleteRoute
  '/patients/$patientId/edit': typeof PatientsPatientIdEditRoute
  '/site-inspections/$siteInspectionId/delete': typeof SiteInspectionsSiteInspectionIdDeleteRoute
  '/site-inspections/$siteInspectionId/edit': typeof SiteInspectionsSiteInspectionIdEditRoute
  '/users/$userId/availability': typeof UsersUserIdAvailabilityRoute
  '/users/$userId/delete': typeof UsersUserIdDeleteRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/users/$userId/signature': typeof UsersUserIdSignatureRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin-email': typeof AdminEmailRoute
  '/bookings': typeof BookingsRoute
  '/clinics': typeof ClinicsRoute
  '/companies': typeof CompaniesRoute
  '/corporate': typeof CorporateRoute
  '/documents': typeof DocumentsRoute
  '/exams': typeof ExamsRoute
  '/job-roles': typeof JobRolesRoute
  '/login': typeof LoginRoute
  '/patients': typeof PatientsRoute
  '/profile': typeof ProfileRoute
  '/site-inspections': typeof SiteInspectionsRoute
  '/tickets': typeof TicketsRoute
  '/users': typeof UsersRoute
  '/weekly-plan': typeof WeeklyPlanRoute
  '/bookings_/new': typeof BookingsNewRoute
  '/bookings_/search': typeof BookingsSearchRoute
  '/clinics_/new': typeof ClinicsNewRoute
  '/companies_/new': typeof CompaniesNewRoute
  '/corporate_/bookings': typeof CorporateBookingsRoute
  '/documents_/bulk-idoneita': typeof DocumentsBulkIdoneitaRoute
  '/documents_/upload': typeof DocumentsUploadRoute
  '/exams_/new': typeof ExamsNewRoute
  '/job-roles_/new': typeof JobRolesNewRoute
  '/patients_/import': typeof PatientsImportRoute
  '/patients_/new': typeof PatientsNewRoute
  '/site-inspections_/new': typeof SiteInspectionsNewRoute
  '/tickets_/$ticketId': typeof TicketsTicketIdRoute
  '/tickets_/new': typeof TicketsNewRoute
  '/users_/new': typeof UsersNewRoute
  '/bookings_/$bookingId/delete': typeof BookingsBookingIdDeleteRoute
  '/bookings_/$bookingId/edit': typeof BookingsBookingIdEditRoute
  '/clinics_/$clinicId/delete': typeof ClinicsClinicIdDeleteRoute
  '/clinics_/$clinicId/edit': typeof ClinicsClinicIdEditRoute
  '/companies_/$companyId/contract': typeof CompaniesCompanyIdContractRoute
  '/companies_/$companyId/delete': typeof CompaniesCompanyIdDeleteRoute
  '/companies_/$companyId/edit': typeof CompaniesCompanyIdEditRoute
  '/documents_/$documentId/delete': typeof DocumentsDocumentIdDeleteRoute
  '/documents_/$documentId/edit': typeof DocumentsDocumentIdEditRoute
  '/exams_/$examId/delete': typeof ExamsExamIdDeleteRoute
  '/exams_/$examId/edit': typeof ExamsExamIdEditRoute
  '/job-roles_/$jobRoleId/delete': typeof JobRolesJobRoleIdDeleteRoute
  '/job-roles_/$jobRoleId/edit': typeof JobRolesJobRoleIdEditRoute
  '/patients_/$patientId/delete': typeof PatientsPatientIdDeleteRoute
  '/patients_/$patientId/edit': typeof PatientsPatientIdEditRoute
  '/site-inspections_/$siteInspectionId/delete': typeof SiteInspectionsSiteInspectionIdDeleteRoute
  '/site-inspections_/$siteInspectionId/edit': typeof SiteInspectionsSiteInspectionIdEditRoute
  '/users_/$userId/availability': typeof UsersUserIdAvailabilityRoute
  '/users_/$userId/delete': typeof UsersUserIdDeleteRoute
  '/users_/$userId/edit': typeof UsersUserIdEditRoute
  '/users_/$userId/signature': typeof UsersUserIdSignatureRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-email'
    | '/bookings'
    | '/clinics'
    | '/companies'
    | '/corporate'
    | '/documents'
    | '/exams'
    | '/job-roles'
    | '/login'
    | '/patients'
    | '/profile'
    | '/site-inspections'
    | '/tickets'
    | '/users'
    | '/weekly-plan'
    | '/bookings/new'
    | '/bookings/search'
    | '/clinics/new'
    | '/companies/new'
    | '/corporate/bookings'
    | '/documents/bulk-idoneita'
    | '/documents/upload'
    | '/exams/new'
    | '/job-roles/new'
    | '/patients/import'
    | '/patients/new'
    | '/site-inspections/new'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/users/new'
    | '/bookings/$bookingId/delete'
    | '/bookings/$bookingId/edit'
    | '/clinics/$clinicId/delete'
    | '/clinics/$clinicId/edit'
    | '/companies/$companyId/contract'
    | '/companies/$companyId/delete'
    | '/companies/$companyId/edit'
    | '/documents/$documentId/delete'
    | '/documents/$documentId/edit'
    | '/exams/$examId/delete'
    | '/exams/$examId/edit'
    | '/job-roles/$jobRoleId/delete'
    | '/job-roles/$jobRoleId/edit'
    | '/patients/$patientId/delete'
    | '/patients/$patientId/edit'
    | '/site-inspections/$siteInspectionId/delete'
    | '/site-inspections/$siteInspectionId/edit'
    | '/users/$userId/availability'
    | '/users/$userId/delete'
    | '/users/$userId/edit'
    | '/users/$userId/signature'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-email'
    | '/bookings'
    | '/clinics'
    | '/companies'
    | '/corporate'
    | '/documents'
    | '/exams'
    | '/job-roles'
    | '/login'
    | '/patients'
    | '/profile'
    | '/site-inspections'
    | '/tickets'
    | '/users'
    | '/weekly-plan'
    | '/bookings/new'
    | '/bookings/search'
    | '/clinics/new'
    | '/companies/new'
    | '/corporate/bookings'
    | '/documents/bulk-idoneita'
    | '/documents/upload'
    | '/exams/new'
    | '/job-roles/new'
    | '/patients/import'
    | '/patients/new'
    | '/site-inspections/new'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/users/new'
    | '/bookings/$bookingId/delete'
    | '/bookings/$bookingId/edit'
    | '/clinics/$clinicId/delete'
    | '/clinics/$clinicId/edit'
    | '/companies/$companyId/contract'
    | '/companies/$companyId/delete'
    | '/companies/$companyId/edit'
    | '/documents/$documentId/delete'
    | '/documents/$documentId/edit'
    | '/exams/$examId/delete'
    | '/exams/$examId/edit'
    | '/job-roles/$jobRoleId/delete'
    | '/job-roles/$jobRoleId/edit'
    | '/patients/$patientId/delete'
    | '/patients/$patientId/edit'
    | '/site-inspections/$siteInspectionId/delete'
    | '/site-inspections/$siteInspectionId/edit'
    | '/users/$userId/availability'
    | '/users/$userId/delete'
    | '/users/$userId/edit'
    | '/users/$userId/signature'
  id:
    | '__root__'
    | '/'
    | '/admin-email'
    | '/bookings'
    | '/clinics'
    | '/companies'
    | '/corporate'
    | '/documents'
    | '/exams'
    | '/job-roles'
    | '/login'
    | '/patients'
    | '/profile'
    | '/site-inspections'
    | '/tickets'
    | '/users'
    | '/weekly-plan'
    | '/bookings_/new'
    | '/bookings_/search'
    | '/clinics_/new'
    | '/companies_/new'
    | '/corporate_/bookings'
    | '/documents_/bulk-idoneita'
    | '/documents_/upload'
    | '/exams_/new'
    | '/job-roles_/new'
    | '/patients_/import'
    | '/patients_/new'
    | '/site-inspections_/new'
    | '/tickets_/$ticketId'
    | '/tickets_/new'
    | '/users_/new'
    | '/bookings_/$bookingId/delete'
    | '/bookings_/$bookingId/edit'
    | '/clinics_/$clinicId/delete'
    | '/clinics_/$clinicId/edit'
    | '/companies_/$companyId/contract'
    | '/companies_/$companyId/delete'
    | '/companies_/$companyId/edit'
    | '/documents_/$documentId/delete'
    | '/documents_/$documentId/edit'
    | '/exams_/$examId/delete'
    | '/exams_/$examId/edit'
    | '/job-roles_/$jobRoleId/delete'
    | '/job-roles_/$jobRoleId/edit'
    | '/patients_/$patientId/delete'
    | '/patients_/$patientId/edit'
    | '/site-inspections_/$siteInspectionId/delete'
    | '/site-inspections_/$siteInspectionId/edit'
    | '/users_/$userId/availability'
    | '/users_/$userId/delete'
    | '/users_/$userId/edit'
    | '/users_/$userId/signature'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminEmailRoute: typeof AdminEmailRoute
  BookingsRoute: typeof BookingsRoute
  ClinicsRoute: typeof ClinicsRoute
  CompaniesRoute: typeof CompaniesRoute
  CorporateRoute: typeof CorporateRoute
  DocumentsRoute: typeof DocumentsRoute
  ExamsRoute: typeof ExamsRoute
  JobRolesRoute: typeof JobRolesRoute
  LoginRoute: typeof LoginRoute
  PatientsRoute: typeof PatientsRoute
  ProfileRoute: typeof ProfileRoute
  SiteInspectionsRoute: typeof SiteInspectionsRoute
  TicketsRoute: typeof TicketsRoute
  UsersRoute: typeof UsersRoute
  WeeklyPlanRoute: typeof WeeklyPlanRoute
  BookingsNewRoute: typeof BookingsNewRoute
  BookingsSearchRoute: typeof BookingsSearchRoute
  ClinicsNewRoute: typeof ClinicsNewRoute
  CompaniesNewRoute: typeof CompaniesNewRoute
  CorporateBookingsRoute: typeof CorporateBookingsRoute
  DocumentsBulkIdoneitaRoute: typeof DocumentsBulkIdoneitaRoute
  DocumentsUploadRoute: typeof DocumentsUploadRoute
  ExamsNewRoute: typeof ExamsNewRoute
  JobRolesNewRoute: typeof JobRolesNewRoute
  PatientsImportRoute: typeof PatientsImportRoute
  PatientsNewRoute: typeof PatientsNewRoute
  SiteInspectionsNewRoute: typeof SiteInspectionsNewRoute
  TicketsTicketIdRoute: typeof TicketsTicketIdRoute
  TicketsNewRoute: typeof TicketsNewRoute
  UsersNewRoute: typeof UsersNewRoute
  BookingsBookingIdDeleteRoute: typeof BookingsBookingIdDeleteRoute
  BookingsBookingIdEditRoute: typeof BookingsBookingIdEditRoute
  ClinicsClinicIdDeleteRoute: typeof ClinicsClinicIdDeleteRoute
  ClinicsClinicIdEditRoute: typeof ClinicsClinicIdEditRoute
  CompaniesCompanyIdContractRoute: typeof CompaniesCompanyIdContractRoute
  CompaniesCompanyIdDeleteRoute: typeof CompaniesCompanyIdDeleteRoute
  CompaniesCompanyIdEditRoute: typeof CompaniesCompanyIdEditRoute
  DocumentsDocumentIdDeleteRoute: typeof DocumentsDocumentIdDeleteRoute
  DocumentsDocumentIdEditRoute: typeof DocumentsDocumentIdEditRoute
  ExamsExamIdDeleteRoute: typeof ExamsExamIdDeleteRoute
  ExamsExamIdEditRoute: typeof ExamsExamIdEditRoute
  JobRolesJobRoleIdDeleteRoute: typeof JobRolesJobRoleIdDeleteRoute
  JobRolesJobRoleIdEditRoute: typeof JobRolesJobRoleIdEditRoute
  PatientsPatientIdDeleteRoute: typeof PatientsPatientIdDeleteRoute
  PatientsPatientIdEditRoute: typeof PatientsPatientIdEditRoute
  SiteInspectionsSiteInspectionIdDeleteRoute: typeof SiteInspectionsSiteInspectionIdDeleteRoute
  SiteInspectionsSiteInspectionIdEditRoute: typeof SiteInspectionsSiteInspectionIdEditRoute
  UsersUserIdAvailabilityRoute: typeof UsersUserIdAvailabilityRoute
  UsersUserIdDeleteRoute: typeof UsersUserIdDeleteRoute
  UsersUserIdEditRoute: typeof UsersUserIdEditRoute
  UsersUserIdSignatureRoute: typeof UsersUserIdSignatureRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/weekly-plan': {
      id: '/weekly-plan'
      path: '/weekly-plan'
      fullPath: '/weekly-plan'
      preLoaderRoute: typeof WeeklyPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-inspections': {
      id: '/site-inspections'
      path: '/site-inspections'
      fullPath: '/site-inspections'
      preLoaderRoute: typeof SiteInspectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients': {
      id: '/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof PatientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-roles': {
      id: '/job-roles'
      path: '/job-roles'
      fullPath: '/job-roles'
      preLoaderRoute: typeof JobRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exams': {
      id: '/exams'
      path: '/exams'
      fullPath: '/exams'
      preLoaderRoute: typeof ExamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/corporate': {
      id: '/corporate'
      path: '/corporate'
      fullPath: '/corporate'
      preLoaderRoute: typeof CorporateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinics': {
      id: '/clinics'
      path: '/clinics'
      fullPath: '/clinics'
      preLoaderRoute: typeof ClinicsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-email': {
      id: '/admin-email'
      path: '/admin-email'
      fullPath: '/admin-email'
      preLoaderRoute: typeof AdminEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/new': {
      id: '/users_/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof UsersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets_/new': {
      id: '/tickets_/new'
      path: '/tickets/new'
      fullPath: '/tickets/new'
      preLoaderRoute: typeof TicketsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets_/$ticketId': {
      id: '/tickets_/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof TicketsTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-inspections_/new': {
      id: '/site-inspections_/new'
      path: '/site-inspections/new'
      fullPath: '/site-inspections/new'
      preLoaderRoute: typeof SiteInspectionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients_/new': {
      id: '/patients_/new'
      path: '/patients/new'
      fullPath: '/patients/new'
      preLoaderRoute: typeof PatientsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients_/import': {
      id: '/patients_/import'
      path: '/patients/import'
      fullPath: '/patients/import'
      preLoaderRoute: typeof PatientsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-roles_/new': {
      id: '/job-roles_/new'
      path: '/job-roles/new'
      fullPath: '/job-roles/new'
      preLoaderRoute: typeof JobRolesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exams_/new': {
      id: '/exams_/new'
      path: '/exams/new'
      fullPath: '/exams/new'
      preLoaderRoute: typeof ExamsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents_/upload': {
      id: '/documents_/upload'
      path: '/documents/upload'
      fullPath: '/documents/upload'
      preLoaderRoute: typeof DocumentsUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents_/bulk-idoneita': {
      id: '/documents_/bulk-idoneita'
      path: '/documents/bulk-idoneita'
      fullPath: '/documents/bulk-idoneita'
      preLoaderRoute: typeof DocumentsBulkIdoneitaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/corporate_/bookings': {
      id: '/corporate_/bookings'
      path: '/corporate/bookings'
      fullPath: '/corporate/bookings'
      preLoaderRoute: typeof CorporateBookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/new': {
      id: '/companies_/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof CompaniesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinics_/new': {
      id: '/clinics_/new'
      path: '/clinics/new'
      fullPath: '/clinics/new'
      preLoaderRoute: typeof ClinicsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings_/search': {
      id: '/bookings_/search'
      path: '/bookings/search'
      fullPath: '/bookings/search'
      preLoaderRoute: typeof BookingsSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings_/new': {
      id: '/bookings_/new'
      path: '/bookings/new'
      fullPath: '/bookings/new'
      preLoaderRoute: typeof BookingsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/$userId/signature': {
      id: '/users_/$userId/signature'
      path: '/users/$userId/signature'
      fullPath: '/users/$userId/signature'
      preLoaderRoute: typeof UsersUserIdSignatureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/$userId/edit': {
      id: '/users_/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof UsersUserIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/$userId/delete': {
      id: '/users_/$userId/delete'
      path: '/users/$userId/delete'
      fullPath: '/users/$userId/delete'
      preLoaderRoute: typeof UsersUserIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/$userId/availability': {
      id: '/users_/$userId/availability'
      path: '/users/$userId/availability'
      fullPath: '/users/$userId/availability'
      preLoaderRoute: typeof UsersUserIdAvailabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-inspections_/$siteInspectionId/edit': {
      id: '/site-inspections_/$siteInspectionId/edit'
      path: '/site-inspections/$siteInspectionId/edit'
      fullPath: '/site-inspections/$siteInspectionId/edit'
      preLoaderRoute: typeof SiteInspectionsSiteInspectionIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-inspections_/$siteInspectionId/delete': {
      id: '/site-inspections_/$siteInspectionId/delete'
      path: '/site-inspections/$siteInspectionId/delete'
      fullPath: '/site-inspections/$siteInspectionId/delete'
      preLoaderRoute: typeof SiteInspectionsSiteInspectionIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients_/$patientId/edit': {
      id: '/patients_/$patientId/edit'
      path: '/patients/$patientId/edit'
      fullPath: '/patients/$patientId/edit'
      preLoaderRoute: typeof PatientsPatientIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients_/$patientId/delete': {
      id: '/patients_/$patientId/delete'
      path: '/patients/$patientId/delete'
      fullPath: '/patients/$patientId/delete'
      preLoaderRoute: typeof PatientsPatientIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-roles_/$jobRoleId/edit': {
      id: '/job-roles_/$jobRoleId/edit'
      path: '/job-roles/$jobRoleId/edit'
      fullPath: '/job-roles/$jobRoleId/edit'
      preLoaderRoute: typeof JobRolesJobRoleIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-roles_/$jobRoleId/delete': {
      id: '/job-roles_/$jobRoleId/delete'
      path: '/job-roles/$jobRoleId/delete'
      fullPath: '/job-roles/$jobRoleId/delete'
      preLoaderRoute: typeof JobRolesJobRoleIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exams_/$examId/edit': {
      id: '/exams_/$examId/edit'
      path: '/exams/$examId/edit'
      fullPath: '/exams/$examId/edit'
      preLoaderRoute: typeof ExamsExamIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exams_/$examId/delete': {
      id: '/exams_/$examId/delete'
      path: '/exams/$examId/delete'
      fullPath: '/exams/$examId/delete'
      preLoaderRoute: typeof ExamsExamIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents_/$documentId/edit': {
      id: '/documents_/$documentId/edit'
      path: '/documents/$documentId/edit'
      fullPath: '/documents/$documentId/edit'
      preLoaderRoute: typeof DocumentsDocumentIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents_/$documentId/delete': {
      id: '/documents_/$documentId/delete'
      path: '/documents/$documentId/delete'
      fullPath: '/documents/$documentId/delete'
      preLoaderRoute: typeof DocumentsDocumentIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId/edit': {
      id: '/companies_/$companyId/edit'
      path: '/companies/$companyId/edit'
      fullPath: '/companies/$companyId/edit'
      preLoaderRoute: typeof CompaniesCompanyIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId/delete': {
      id: '/companies_/$companyId/delete'
      path: '/companies/$companyId/delete'
      fullPath: '/companies/$companyId/delete'
      preLoaderRoute: typeof CompaniesCompanyIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies_/$companyId/contract': {
      id: '/companies_/$companyId/contract'
      path: '/companies/$companyId/contract'
      fullPath: '/companies/$companyId/contract'
      preLoaderRoute: typeof CompaniesCompanyIdContractRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinics_/$clinicId/edit': {
      id: '/clinics_/$clinicId/edit'
      path: '/clinics/$clinicId/edit'
      fullPath: '/clinics/$clinicId/edit'
      preLoaderRoute: typeof ClinicsClinicIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinics_/$clinicId/delete': {
      id: '/clinics_/$clinicId/delete'
      path: '/clinics/$clinicId/delete'
      fullPath: '/clinics/$clinicId/delete'
      preLoaderRoute: typeof ClinicsClinicIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings_/$bookingId/edit': {
      id: '/bookings_/$bookingId/edit'
      path: '/bookings/$bookingId/edit'
      fullPath: '/bookings/$bookingId/edit'
      preLoaderRoute: typeof BookingsBookingIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings_/$bookingId/delete': {
      id: '/bookings_/$bookingId/delete'
      path: '/bookings/$bookingId/delete'
      fullPath: '/bookings/$bookingId/delete'
      preLoaderRoute: typeof BookingsBookingIdDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminEmailRoute: AdminEmailRoute,
  BookingsRoute: BookingsRoute,
  ClinicsRoute: ClinicsRoute,
  CompaniesRoute: CompaniesRoute,
  CorporateRoute: CorporateRoute,
  DocumentsRoute: DocumentsRoute,
  ExamsRoute: ExamsRoute,
  JobRolesRoute: JobRolesRoute,
  LoginRoute: LoginRoute,
  PatientsRoute: PatientsRoute,
  ProfileRoute: ProfileRoute,
  SiteInspectionsRoute: SiteInspectionsRoute,
  TicketsRoute: TicketsRoute,
  UsersRoute: UsersRoute,
  WeeklyPlanRoute: WeeklyPlanRoute,
  BookingsNewRoute: BookingsNewRoute,
  BookingsSearchRoute: BookingsSearchRoute,
  ClinicsNewRoute: ClinicsNewRoute,
  CompaniesNewRoute: CompaniesNewRoute,
  CorporateBookingsRoute: CorporateBookingsRoute,
  DocumentsBulkIdoneitaRoute: DocumentsBulkIdoneitaRoute,
  DocumentsUploadRoute: DocumentsUploadRoute,
  ExamsNewRoute: ExamsNewRoute,
  JobRolesNewRoute: JobRolesNewRoute,
  PatientsImportRoute: PatientsImportRoute,
  PatientsNewRoute: PatientsNewRoute,
  SiteInspectionsNewRoute: SiteInspectionsNewRoute,
  TicketsTicketIdRoute: TicketsTicketIdRoute,
  TicketsNewRoute: TicketsNewRoute,
  UsersNewRoute: UsersNewRoute,
  BookingsBookingIdDeleteRoute: BookingsBookingIdDeleteRoute,
  BookingsBookingIdEditRoute: BookingsBookingIdEditRoute,
  ClinicsClinicIdDeleteRoute: ClinicsClinicIdDeleteRoute,
  ClinicsClinicIdEditRoute: ClinicsClinicIdEditRoute,
  CompaniesCompanyIdContractRoute: CompaniesCompanyIdContractRoute,
  CompaniesCompanyIdDeleteRoute: CompaniesCompanyIdDeleteRoute,
  CompaniesCompanyIdEditRoute: CompaniesCompanyIdEditRoute,
  DocumentsDocumentIdDeleteRoute: DocumentsDocumentIdDeleteRoute,
  DocumentsDocumentIdEditRoute: DocumentsDocumentIdEditRoute,
  ExamsExamIdDeleteRoute: ExamsExamIdDeleteRoute,
  ExamsExamIdEditRoute: ExamsExamIdEditRoute,
  JobRolesJobRoleIdDeleteRoute: JobRolesJobRoleIdDeleteRoute,
  JobRolesJobRoleIdEditRoute: JobRolesJobRoleIdEditRoute,
  PatientsPatientIdDeleteRoute: PatientsPatientIdDeleteRoute,
  PatientsPatientIdEditRoute: PatientsPatientIdEditRoute,
  SiteInspectionsSiteInspectionIdDeleteRoute:
    SiteInspectionsSiteInspectionIdDeleteRoute,
  SiteInspectionsSiteInspectionIdEditRoute:
    SiteInspectionsSiteInspectionIdEditRoute,
  UsersUserIdAvailabilityRoute: UsersUserIdAvailabilityRoute,
  UsersUserIdDeleteRoute: UsersUserIdDeleteRoute,
  UsersUserIdEditRoute: UsersUserIdEditRoute,
  UsersUserIdSignatureRoute: UsersUserIdSignatureRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
